import React, { FC, useEffect } from 'react';
import { Button } from 'components/ui';
import { useHistory } from 'react-router';
import routesByName from 'constants/routes';
import AppCard from '../AppCard/AppCard';
import { useDispatch } from 'react-redux';
import { getApps } from '../store/actions';
import { useQuery } from '@redux-requests/react';
import { AppsConstants } from '../store/constants';
import { NoResults, TimifyLoader } from 'components';
import { t } from 'utils';

import styles from './AppsDashboard.module.scss';

const AppsList: FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { loading, data: appList } = useQuery({ type: AppsConstants.APPS });
  const hasApps = appList?.length > 0;

  useEffect(() => {
    dispatch(getApps());
  }, [dispatch]);

  return (
    <div className='container'>
      <section className={styles.root}>
        <div className={styles.head}>
          <h2 className={styles.title}>{t('your.apps')}</h2>
          <Button
            className={styles.newAppButton}
            inline
            onClick={() => history.push(routesByName.apps.createApp)}
          >
            <span className='fas fa-plus mr-2' />
            {t('new.app')}
          </Button>
        </div>
        {loading ? (
          <TimifyLoader />
        ) : !hasApps ? (
          <NoResults>{t('global.noResults')}</NoResults>
        ) : (
          <ul className={styles.list}>
            {appList?.map((app: any, index: number) => (
              <li key={app.id}>
                <AppCard {...app} index={index} />
              </li>
            ))}
          </ul>
        )}
      </section>
    </div>
  );
};

export default AppsList;
